<template>
    <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container-fluid">
            <img class="avatar border-white p-2" v-bind:src="id_photo"
                @error="$event.target.src = 'http://pic.e-cmd.org/cmdpic/avatar.jpg'" id="logo_mobile" style="width:80px; display:none; border-radius:50%; height: 80px;
        object-fit: cover;">

            <a class="navbar-brand">{{ profili.emri }} {{ profili.mbiemri }} <span class="text-danger"> {{ profili.indeksi
            }} </span></a>

            <!-- Hamburger Menu -->
            <div id="menu-wrapper" class="navbar-toggler" type="button" @click="toggleSidebar"
                :aria-expanded="$sidebar.showSidebar" aria-label="Toggle navigation">
                <div id="hamburger-menu"><span></span><span></span><span></span> </div>
                <!-- hamburger-menu -->
            </div>

            <div class="collapse navbar-collapse" id="njoftimet">
                <ul class="navbar-nav ml-auto">
                    <drop-down class="nav-item" title="Lajmërimet" title-classes="nav-link" icon="ti-bell">
                        <a class="dropdown-item" v-for="item in njoftimet" target="_blank">
                            <a :href=item.porosia target="_blank">{{ item.titulli }}<br><small>{{ item.data }}</small></a>
                        </a>
                    </drop-down>
                    <li class="nav-item">
                        <a class="nav-link" v-on:click="Logout()" style="cursor:pointer;">
                            <i class="ti-user"></i>
                            <p>Çkyqu</p>
                        </a>
                    </li>

                </ul>
            </div>

        </div>
    </nav>
</template>

<script>
import { APISettings } from '../../api/config.js'
import moment from 'moment'
import Vuetify from 'vuetify'
import $ from 'jquery'


export default {
    computed: {
        routeName()
        {
            const { name } = this.$route;
            return this.capitalizeFirstLetter(name);
        },
    },
    vuetify: new Vuetify({
        theme: {
            themes: {
                dark: {
                    primary: '#16ACA7'
                }
            },
            dark: true
        }
    }),
    data()
    {
        return {
            activeNotifications: false,
            profili: {},
            njoftimet: [],
            id_photo: "",

        };
    },
    methods: {

        capitalizeFirstLetter(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown()
        {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown()
        {
            this.activeNotifications = false;
        },
        toggleSidebar()
        {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        hideSidebar()
        {
            this.$sidebar.displaySidebar(false);
        },

        Logout()
        {

            localStorage.setItem("user", "");
            var allCookies = document.cookie.split(';');

            for (var i = 0; i < allCookies.length; i++)
                document.cookie = allCookies[i] + "=;expires=" +
                    new Date(0).toUTCString();
            this.$router.push('/');
        },

        // Profili
        getData()
        {
            var get_token = this.$cookies.get("accesstoken");

            fetch(APISettings.baseURL + `Profili/getProfiliNew/`, {

                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + get_token
                },
            })
                .then(
                    (signinResponse) =>
                    {
                        this.loader = true;
                        signinResponse.json().then((res) =>
                        {
                            if (signinResponse.status === 200)
                            {
                                res.forEach(obj =>
                                {
                                    this.profili = obj;
                                    this.id_photo = `http://pic.e-cmd.org/cmdpic/1005/${this.profili.studentiGUID}_thumbnail.jpg`;
                                });
                            } else if (signinResponse.status === 400)
                            {
                                console.log("ERROR DATA1");
                            }
                        })
                    }).catch(error =>
                    {
                        console.log("ERROR DATA2");
                    })
        },

        // Njoftimet
        getData1()
        {
            var get_token = this.$cookies.get("accesstoken");
            fetch(APISettings.baseURL + `Njoftimet/getNjoftimetStudent/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + get_token
                },
            })
                .then(
                    (signinResponse) =>
                    {
                        this.loader = true;
                        signinResponse.json().then((res) =>
                        {
                            if (signinResponse.status === 200)
                            {

                                res.forEach((obj) =>
                                {
                                    const formattedDate = moment(obj.data).format('DD/MM/YYYY');
                                    obj.data = formattedDate;
                                    this.njoftimet = res;
                                    if (this.njoftimet.length < 7)
                                    {
                                        this.njoftimet = res;
                                    } else
                                    {
                                        this.njoftimet.length = 7;
                                    }

                                    if (obj.titulli === undefined)
                                    {
                                        obj.titulli = "Kliko ketu"
                                    }
                                });
                            } else if (signinResponse.status === 400)
                            {
                                console.log("ERROR DATA1");
                            }
                            this.loader = false;
                        })
                    }).catch(error =>
                    {
                        console.log("ERROR DATA2");
                    })
        },

    },
    beforeMount()
    {
        this.getData();
        this.getData1();
    },

};
$(function ()
{
    $("#menu-wrapper").click(function (event)
    {
        event.stopPropagation();
        $("#hamburger-menu").toggleClass("open");
    });

    $(document.body).click(function ()
    {
        $("#hamburger-menu").removeClass("open");
    });
});
</script>

<style scoped>
::v-deep .v-application--wrap {
    min-height: fit-content;
}


#menu-wrapper {
    overflow: hidden;
    max-width: 100%;
    cursor: pointer;
}

#menu-wrapper #hamburger-menu {
    position: relative;
    width: 25px;
    height: 20px;
    margin: 15px;

}

#menu-wrapper #hamburger-menu span {
    opacity: 1;
    left: 0;
    display: block;
    width: 100%;
    height: 2px;
    border-radius: 10px;
    color: rgba(0, 0, 0, 0.5);
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    transform: rotate(0deg);
    transition: .4s ease-in-out;
}

#menu-wrapper #hamburger-menu span:nth-child(1) {
    top: 0;
}

#menu-wrapper #hamburger-menu span:nth-child(2) {
    top: 9px;
}

#menu-wrapper #hamburger-menu span:nth-child(3) {
    top: 18px;
}

#menu-wrapper #hamburger-menu.open span:nth-child(1) {
    transform: translateY(9px) rotate(135deg);
}

#menu-wrapper #hamburger-menu.open span:nth-child(2) {
    opacity: 0;
    transform: translateX(-60px);
}

#menu-wrapper #hamburger-menu.open span:nth-child(3) {
    transform: translateY(-9px) rotate(-135deg);
}

.navbar-nav>li.show>.dropdown-menu,
.dropdown.show .dropdown-menu {
    position: absolute;
    right: 0 !important;
    left: -200px !important;

}

.navbar-nav>li a>a {
    white-space: break-spaces !important;
    margin-left: 0;

}
</style>
`
